import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo, useCallback, useState } from 'react';
import styled from 'styled-components';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { IS_DEAL_CLOSED } from '../v2/constants/AdditionalPropertyNames';
import { useAdditionalPropertyValues } from '../v2/hooks/useAdditionalPropertyValues';
import { useGetHasScope } from '../v2/hooks/useGetHasScope';
import PropertyInputNumber from './PropertyInputNumber';
const StyledRow = styled.div.withConfig({
  displayName: "PropertyInputDealExchangeRateWrapper__StyledRow",
  componentId: "sc-1gch2r5-0"
})(["display:flex;align-items:center;"]);

const hasValue = value => {
  return value !== undefined && value !== null && value !== '';
}; // Exchange rate is being made editable, but only in limited cases. The
// property is changing from a calculated property to an editable property
// that is updated by a backend system. However, the automatic updates will
// only be to open deals. Any other updates will be rejected by the backend.
// If the deal is closed, then we will allow super-admins to edit the exchange
// rate. The framework doesn't support this well now so we will:
//   * Make the input read-only if we know the deal is open
//   * Add a help icon letting the user know when the exchange rate is editable
//     and by whom. This icon is only shown if the property is editable and has
//     a value.


const PropertyInputDealExchangeRateWrapper = props => {
  const {
    hasScope,
    loading
  } = useGetHasScope();
  const [isDealClosed] = useAdditionalPropertyValues([IS_DEAL_CLOSED]);
  const [focused, setFocused] = useState(false);
  const {
    onBlur,
    onFocus
  } = props;
  const handleFocus = useCallback(e => {
    setFocused(true);

    if (onFocus) {
      onFocus(e);
    }
  }, [onFocus]);
  const handleBlur = useCallback(e => {
    setFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  }, [onBlur]);
  const showHelpIcon = !props.readOnly && (hasValue(props.value) || focused);
  const isExchangeRateEditable = isDealClosed === 'true' && hasScope && hasScope('super-admin');
  return /*#__PURE__*/_jsxs(StyledRow, {
    children: [showHelpIcon && /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-right-1",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputDealExchangeRateWrapper.help"
      }),
      tooltipPlacement: "top right"
    }), /*#__PURE__*/_jsx(PropertyInputNumber, Object.assign({}, props, {
      "data-userinfo-loading": loading,
      onBlur: handleBlur,
      onFocus: handleFocus,
      readOnly: props.readOnly || !isExchangeRateEditable
    }))]
  });
};

export default /*#__PURE__*/memo(PropertyInputDealExchangeRateWrapper);